import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 画像コンテンツ
 */
export class ContentImage extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): ContentImage {
    return new ContentImage(value);
  }

  /**
   * 表示を返す
   * @returns 表示
   */
  override toString() {
    return this.value;
  }
}
